const enLocale = {
    "e-mail": "Email address",
    "password": "Password",
    "existing_user": "Existing user",
    "new_user": "New user",
    "forgot_password": "Forgot password",
    "login": "Log in",
    "bad_credentials": "Invalid email address or password.",
    "your_name": "Full name",
    "first_name": "First name",
    "last_name": "Last name",
    "address": "Address",
    "register": "Register",
    "accept_privacy_and_terms": "I accept the <0>Privacy Policy</0> and the <1>Terms & Conditions</1>.",
    "read_more": "Read more",
    "or_login_with": "or log in with",
    "field_required": "This field is required.",
    "email_field_not_valid": "Please enter a valid email address.",
    "choose_language": "Choose language",
    "home": "Home",
    "confirm_password": "Confirm password",
    "confirmation_mail_message": "A confirmation email has been sent to your email address.",
    "log_out": "Log out",
    "wishes": "Wishes",
    "about": "About us",
    "logout_success": "You have successfully logged out",
    "sort_by": "Sort by",
    "password_regex_not_valid": "Password requirements are not met.",
    "created_at": "Creation time",
    "end_time": "Time left",
    "tickets_count": "Trending",
    "times_read": "Views",
    "search_wish": "Search wish",
    "search": "Search",
    "min": "Min",
    "max": "Max",
    "make_a_wish": "Make a wish",
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds",
    "days_short": "D",
    "hours_short": "Hrs",
    "minutes_short": "Min",
    "seconds_short": "Sec",
    "description": "Description",
    "specification": "Specifications",
    "admin_panel": "Admin panel",
    "client_panel": "Client panel",
    "dashboard": "Dashboard",
    "categories": "Categories",
    "questions": "Questions",
    "category": "Category",
    "filters": "Filters",
    "pending": "Pending",
    "active": "Active",
    "finished": "Finished",
    "no_data": "No data available",
    "create_wish": "Create wish",
    "edit_wish": "Edit wish",
    "close": "Close",
    "save": "Save",
    "use": "Use",
    "split_by_new_line": "Split by new line",
    "wish": "wish",
    "delete_wish_confirmation_message": "Are you sure you want to delete the wish with ID:",
    "publish_wish_confirmation_message": "Are you sure you want to publish the wish with ID:",
    "delete": "Delete",
    "publish": "Publish",
    "reset": "Reset",
    "create_category": "Create category",
    "delete_category_confirmation_message": "Are you sure you want to delete the category with ID:",
    "delete_category": "Delete category",
    "scan_winner": "Scan winner",
    "enter_info": "Enter info",
    "upload_images": "Upload images",
    "forgot_password_message": "Enter your email address and we'll send you a link to reset your password.",
    "submit": "Submit",
    "reset_password": "Reset password",
    "new_password": "New password",
    "error_forgot_password": "Error sending reset password email. Please try again later.",
    "forgot_password_success": "A reset password email has been sent to {{email}}. Check your inbox and click the link to reset your password.",
    "error_reset_password": "Error resetting your password. Please try again later.",
    "reset_password_success": "Your password has been changed successfully.",
    "didnt_get_email": "Didn't get the email? Make sure your email address is correct.",
    "resend": "Resend",
    "change_email": "Change email",
    "did_you_mean": "Did you mean",
    "link_expired": "Your link has expired or is invalid. Request a new one.",
    "requirements": "Requirements:",
    "eight_characters": "At least 8 characters long",
    "include_lowercase": "Includes a lowercase character",
    "include_uppercase": "Includes an uppercase character",
    "include_special": "Includes a special character",
    "your_profile": "Your profile",
    "your_wishes": "Your wishes",
    "points": "Points",
    "buy_now": "Buy now",
    "edit_profile": "Update your profile",
    "city": "City",
    "phone_number": "Phone number",
    "update": "Update",
    "success_update_user": "Your profile has been updated successfully.",
    "error_update_user": "An error occurred while updating your profile.",
    "vouchers": "Vouchers",
    "odds": "Odds of winning",
    "winners": "Winners",
    "winner": "Winner",
    "see_winners": "See winners ({{count}})",
    "winners_announced_on": "Winners announced on {{date}}.",
    "you_are_one_of_lucky_winners": "You are one of the lucky winners!",
    "you_are_not_one_of_lucky_winners": "You are not one of the lucky winners.",
    "login_register": "Log in / Register",
    "see_more": "See more",
    "trending_draws": "Trending draws",
    "partner_vouchers": "Partner vouchers",
    "partner_vouchers_subtitle": "Buy vouchers from our partners, enjoy their benefits, and earn Genie points to reduce draw entry cost.",
    "how_it_works": "How it works?",
    "how_it_works_jsonld_description": "Follow the steps to join limited-entry draws and increase your chances of winning.",
    "home_how_it_works_subtitle": "Join limited-entry draws to win big prizes. With every entry, you increase your chances of winning.",
    "past_winners": "Past winners",
    "lets_begin": "Let's begin",
    "start_wishing": "Make your wish come true",
    "register_now_and_start_wishing": "Register now and start wishing!",
    "learn_more": "Learn more",
    "learn_more_rules": "Learn more about our terms",
    "passwords_not_match": "Passwords do not match.",
    "wishlist": "Wishlist",
    "points_leaderboard": "Points leaderboard",
    "cost": "Price",
    "similar_wishes": "Similar wishes",
    "back": "Back",
    "something_went_wrong": "Something went wrong",
    "working_on_fixing_problem": "We’re working on fixing the problem",
    "refresh_page": "Refresh page",
    "available_vouchers": "Available vouchers",
    "bought_vouchers": "Bought vouchers",
    "obtained_entries": "Obtained entries",
    "category_popularity": "Category popularity",
    "start_date": "Start date",
    "end_date": "End date",
    "bought_vouchers_per_category": "Bought vouchers per category",
    "percentage_total_bought": "Percentage of bought vouchers / total vouchers",
    "displayed_categories": "Displayed categories",
    "users": "Users",
    "new_users": "New users",
    "proceed_to_payment": "Proceed to payment",
    "proceed_to_payment_short": "To payment",
    "obtain_more_entries_hint": "Increase your chances of winning by buying more entries.",
    "continue": "Continue",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "wish_popularity_per_voucher_price": "Wish popularity per price",
    "voucher_popularity_per_points_award": "Voucher popularity per points award",
    "users_per_gender": "Users per gender",
    "explore_more": "Explore more",
    "privacy": "Privacy Policy",
    "privacy_footer": "Privacy Policy",
    "terms": "Terms & Conditions",
    "blogs": "Blogs",
    "contact": "Contact",
    "legal": "Legal",
    "payment_methods": "Payment methods",
    "trusted_partners": "Trusted partners",
    "secure_payments": "Secure payments via trusted providers.",
    "all_rights_reserved": "All rights reserved.",
    "message": "Message",
    "contact_us": "Contact us",
    "why_genie": "Why Genie?",
    "success_create_contact": "Thank you! We’ve received your message and will get back to you as soon as possible.",
    "error_create_contact": "Error sending your message. Please try again later.",
    "load_more": "Load more",
    "responded": "Responded",
    "messages": "Messages",
    "expenses": "Expenses",
    "create_expense": "Create expense",
    "update_expense": "Update expense",
    "delete_expense": "Delete expense",
    "delete_expense_confirmation_message": "Are you sure you want to delete this expense?",
    "expenses_per_month": "Expenses per month",
    "price": "Price",
    "delete_contact_confirmation_message": "Are you sure you want to delete this message?",
    "create_blog": "Create blog",
    "update_blog": "Update blog",
    "delete_blog_confirmation_message": "Are you sure you want to delete this blog?",
    "buy_voucher_one": "Buy voucher",
    "buy_voucher_other": "Buy vouchers",
    "confirm": "Confirm",
    "you": "You",
    "see_wish_details": "Wish details",
    "error_occurred": "An error occurred. Please try again.",
    "error_invalid_request_data": "Some data is invalid. Please review your input and try again.",
    "error_email_address_invalid": "This email address looks invalid. Please check it and try again.",
    "error_email_domain_not_found": "We couldn’t find that email domain. Please check for a typo (for example, gmail.com).",
    "error_email_delivery_failed": "We couldn’t deliver email to this address. Please check it or use another one.",
    "coming_soon": "Coming soon",
    "points_reward_tooltip": "Points awarded for each voucher purchased.",
    "page_not_found": "Page not found",
    "page_not_exist": "This page doesn’t exist or was removed.",
    "suggest_home": "We suggest you go back to the home page.",
    "bought": "Bought",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "notifications": "Notifications",
    "mark_all_as_read": "Mark all as read",
    "no_notifications": "You don’t have any notifications right now.",
    "only_unread": "Only unread",
    "subscribe_newsletter": "I want to receive news by email",
    "error_change_language": "An error occurred while changing the language.",
    "wheel_spins_dialog_title": "Daily wheel of points",
    "points_award_dialog_title": "Points awarded",
    "canceled_order_points_award_title": "Canceled order compensation points",
    "points_history_available_now": "Available now",
    "points_history_status": "Current state",
    "points_history_validity": "Validity",
    "points_history_status_active": "Active",
    "points_history_status_available": "Available",
    "points_history_status_partly_used": "Partly used",
    "points_history_status_fully_used": "Fully used",
    "points_history_status_spent": "Spent",
    "points_history_status_expired": "Expired",
    "points_history_status_no_expiry": "No expiry",
    "points_history_status_used": "Used",
    "points_history_valid_until": "Valid until {{date}}",
    "points_history_expired_on": "Expired on {{date}}",
    "points_history_remaining_points": "Available now: {{count}}",
    "points_history_gift_recipient": "Gift to",
    "points_congratulations_one": "Congratulations! You’ve received {{count}} point.",
    "points_congratulations_other": "Congratulations! You’ve received {{count}} points.",
    "spin_the_wheel": "Spin the wheel",
    "spin_the_wheel_points_expiry_notice": "Points earned from the wheel expire at the end of the month if they are not used.",
    "continue_browsing": "You can now continue browsing the app.",
    "unsubscribe_success_title": "Unsubscribe",
    "unsubscribe_success_question": "Are you sure you want to unsubscribe from receiving news via email?",
    "unsubscribe_success_description": "You’ve been successfully unsubscribed from news emails.",
    "resubscribe_message": "You can re-subscribe anytime by updating your profile.",
    "unsubscribe_error": "Error while unsubscribing. Please try again later.",
    "await_wish_draw": "The draw is in progress",
    "notification": "Notification",
    "send": "Send",
    "notification_send_success": "Notification sent successfully to the selected users.",
    "notification_send_error": "Error sending notification. Please try again.",
    "preview": "Preview",
    "history_of_transactions": "History of transactions",
    "transaction_id": "Transaction ID",
    "date": "Date",
    "amount": "Amount",
    "status": "Status",
    "PENDING": "PENDING",
    "SUCCESSFUL": "SUCCESSFUL",
    "FAILED": "FAILED",
    "contact_us_subtitle": "For issues or collaboration opportunities — we value your feedback and look forward to connecting with you.",
    "buy_vouchers_notice": "*By buying vouchers, you agree to the <0>Terms & Conditions</0>. Bought vouchers for this wish can be redeemed until: {{expiry}}.",
    "profile_incomplete": "Your profile is incomplete",
    "partners": "Partners",
    "view_vouchers": "View vouchers",
    "view_entries": "View entries",
    "entry_id": "Entry ID",
    "winner_voucher": "WINNER",
    "non_winner_voucher": "NON-WINNER",
    "cookie_policy": "We use cookies for analytics and marketing — read more in our <0>Privacy Policy</0>.",
    "accept": "Accept",
    "available": "Available",
    "obtained": "Obtained",
    "terminate_wish_confirmation_message": "Are you sure you want to terminate the wish with ID:",
    "terminate": "Terminate",
    "terminated": "Terminated",
    "scan_again": "Scan again",
    "all_vouchers_bought": "There are no available vouchers.",
    "all_entries_obtained": "There are no available entries.",
    "url_copied": "URL copied to clipboard",
    "other": "Other",
    "create_update_document": "Create / Update document",
    "documents": "Documents",
    "who_are_we": "Who are we?",
    "add_new": "Add new",
    "effective": "Effective:",
    "images": "Images",
    "delete_image_confirmation_message": "Are you sure you want to delete this image?",
    "config": "Config",
    "changes_saved_success": "Changes have been saved successfully.",
    "create_update_config": "Create / Update config",
    "announced": "Announced:",
    "reschedule_wish_confirmation_message": "Are you sure you want to reschedule the draw for the wish with ID:",
    "reschedule": "Reschedule",
    "enter_amount": "Enter amount",
    "payment": "Payment",
    "confirmation": "Confirmation",
    "or_enter_custom_amount": "or custom amount",
    "minimum_amount": "Minimum amount is {{minimum}}",
    "faq": "Frequently Asked Questions",
    "faq_short": "FAQ",
    "check_faq_short": "Check our <0>Frequently Asked Questions</0> for answers. If you still need help, send us a message below!",
    "still_not_clear": "Still have questions? Check out our <0>Frequently Asked Questions</0> or <1>send us a message</1> for further assistance!",
    "congratulations": "Congratulations!",
    "you_are_the_lucky_winner": "{{fullName}}, you are one of the lucky winners of {{wishName}}!",
    "our_team_will_contact_you": "Our team will contact you with details on how to collect your reward.",
    "this_qr_code_must_be_presented": "*This QR code must be presented to claim your prize.",
    "install": "Install",
    "get_for_seamless_experience": "Get the Genie app for a seamless experience!",
    "claim_prize": "Claim prize",
    "expand": "Expand",
    "collapse": "Collapse",
    "this_month": "This month",
    "January": "January",
    "February": "February",
    "March": "March",
    "April": "April",
    "May": "May",
    "June": "June",
    "July": "July",
    "August": "August",
    "September": "September",
    "October": "October",
    "November": "November",
    "December": "December",
    "no_active_wishes_title": "No active wishes",
    "no_active_wishes_subtitle": "Active wishes you’re participating in will appear here. Explore more wishes now!",
    "no_finished_wishes_title": "No finished wishes",
    "no_finished_wishes_subtitle": "Finished wishes you’ve participated in will appear here. Explore more wishes now!",
    "no_wishlist_wishes_title": "No wishes in wishlist",
    "no_wishlist_wishes_subtitle": "Wishes you save will appear here. Explore more wishes now!",
    "explore_wishes": "Explore wishes",
    "send_as_gift": "Send as gift",
    "send_voucher_as_gift_tooltip": "Gift someone a voucher! Enter their name and email, and they’ll receive a message with instructions to redeem it.",
    "send_entry_as_gift_tooltip": "Gift someone an entry! Enter their name and email, and they’ll receive a message with instructions to redeem it.",
    "recipient_email": "Recipient’s email",
    "recipient_name": "Recipient’s name",
    "personalized_message": "Personalized message",
    "or_enter_manually": "or enter manually",
    "voucher_code": "Voucher code",
    "help": "Help",
    "guide": "Guide",
    "discover_guide_text": "Explore the Genie guide",
    "explore": "Explore",
    "check_out_wish": "Check out this wish – I think you’ll like it!",
    "unsaved_changes_message": "You have unsaved changes. If you continue, they will be lost. Are you sure?",
    "email_send_success": "Email sent successfully.",
    "email_send_error": "Error sending email. Please try again.",
    "e-mails": "Emails",
    "optional_fields": "Optional fields",
    "spin_the_wheel_explanation": "Besides earning points by buying vouchers, you can spin the wheel once a day for a chance to earn extra points.",
    "coming_soon_title": "Wishes soon will become reality!",
    "coming_soon_subtitle": "Be among the first to stay up to date with all information and news!",
    "giveaway_note": "You can participate only once in this giveaway.",
    "redraw_winners_confirmation_message": "Are you sure you want to redraw the winners for the wish with ID:",
    "already_participated": "You are already participating in this giveaway.",
    "app_description": "Join limited-entry draws to win big prizes. Buy partner vouchers and earn Genie points that reduce draw entry cost.",
    "app_keywords": "Genie, draws, limited-entry draws, prize draws, entries, big prizes, partner vouchers, Genie points, giveaways",
    "app_jsonld_description": "Genie is a web platform focused on limited-entry prize draws. Users can buy entries to compete for big prizes, and can also buy partner vouchers to enjoy benefits and earn Genie points that help reduce draw entry cost.",
    "genie_name": "Genie",
    "clients": "Clients",
    "update_client": "Update client",
    "create_client": "Create client",
    "validate_voucher": "Validate voucher",
    "validate_again": "Validate again",
    "total": "Total",
    "expired": "Expired",
    "redeemed": "Redeemed",
    "details": "Details",
    "bank_fee": "Bank fee",
    "expires": "Expires",
    "active_voucher": "Active",
    "expired_voucher": "Expired",
    "redeemed_voucher": "Redeemed",
    "draw": "Draw",
    "draws": "Draws",
    "comment": "Comment",
    "leave_a_comment": "Optional: Leave a comment about your recent validation.",
    "leave_comment_success": "You can find voucher comments in the client panel.",
    "select_wish_to_start": "Select a wish to get started.",
    "no_vouchers_yet": "You don’t have any vouchers yet.",
    "no_wishes_yet": "You don’t have any wishes yet.",
    "no_draws_yet": "You don’t have any draws yet.",
    "update_comment": "Update comment",
    "client_vouchers_bought": "{{bought}}/{{total}} vouchers bought",
    "client_entries_obtained": "{{obtained}}/{{total}} entries obtained",
    "voucher": "Voucher",
    "duplicate_wish_confirmation_message": "Are you sure you want to duplicate the wish with ID:",
    "duplicate": "Duplicate",
    "entries": "Entries",
    "question_step": "Question",
    "create_question": "Create question",
    "update_question": "Update question",
    "delete_question": "Delete question",
    "delete_question_confirmation_message": "Are you sure you want to delete the question with ID:",
    "answers": "Answers",
    "add_answer": "Add answer",
    "correct_answer": "Correct answer",
    "question_list_error": "Error loading questions. Please try again.",
    "question_form_invalid": "Please complete all question fields and mark one correct answer.",
    "question_create_success": "Question created successfully.",
    "question_create_error": "Error creating question. Please try again.",
    "question_update_success": "Question updated successfully.",
    "question_update_error": "Error updating question. Please try again.",
    "question_delete_success": "Question deleted successfully.",
    "question_delete_error": "Error deleting question. Please try again.",
    "paying_users": "Paying users",
    "answer_question_to_continue": "Answer correctly to continue to checkout.",
    "question_unavailable": "Question is currently unavailable. Please load a new one.",
    "incorrect_answer_message": "Incorrect answer. You can't continue with this question.",
    "question_answer_wrong_title": "Wrong answer",
    "question_answer_wrong_message": "Your answer was not correct, so you can't continue to checkout.",
    "question_answer_wrong_hint": "Close this modal and try again with a new question.",
    "new_question": "New question",
    "obtain_entries_confirmation_one": "Are you sure you want to participate with {{count}} entry for {{wishName}}?",
    "obtain_entries_confirmation_other": "Are you sure you want to participate with {{count}} entries for {{wishName}}?",
    "success_gift_obtain_entries_one": "You successfully gifted {{count}} entry for this wish.",
    "success_gift_obtain_entries_other": "You successfully gifted {{count}} entries for this wish.",
    "success_obtain_entries_one": "You successfully obtained {{count}} entry for this wish. Good luck!",
    "success_obtain_entries_other": "You successfully obtained {{count}} entries for this wish. Good luck!",
    "obtain_entries_notice": "*By participating in this wish, each participant agrees to the <0>Terms & Conditions</0>.",
    "not_enough_points_message_one": "You don't have enough Genie points to participate with {{count}} entry for {{wishName}}. You currently have {{currentPoints}} points and need {{missingPoints}} more.",
    "not_enough_points_message_other": "You don't have enough Genie points to participate with {{count}} entries for {{wishName}}. You currently have {{currentPoints}} points and need {{missingPoints}} more.",
    "cost_genie_points_one": "This will cost {{count}} Genie point.",
    "cost_genie_points_other": "This will cost {{count}} Genie points.",
    "all": "All",
    "wish_type": "Wish type",
    "available_points": "Available points",
    "subtotal": "Subtotal",
    "points_discount": "Points discount",
    "use_points_for_discount": "Use points to reduce total",
    "points_conversion_rate": "1 Genie point = 1 MKD",
    "points_to_use": "Points to use",
    "max_points_to_use": "You can use up to {{count}} points.",
    "spin_again": "Come back in {{timeLeft}} to spin again!",
    "points_to_use_tooltip": "Available Genie points you can apply as a discount at draw checkout (1 Genie point = 1 MKD).",
    "start_and_free_points": "Register now and get {{points}} free points",
    "no_active_wishes": "There are no active wishes. Check back later!",
    "no_active_wishes_from_type": "There are no active wishes of this type. Check back later!",
    "free_entry": "Free entry",
    "free_voucher": "Free voucher",
    "wish_has_finished": "This wish has finished",
    "ios_install": "Just tap <0></0> and \"Add to Home Screen\" to install it.",
    "view_points_history": "View points history",
    "change": "Change",
    "title": "Title",
    "genie_points": "Genie points",
    "points_used": "Points used",
    "gift_label": "Gift",
    "disable_client_user": "Disable client user",
    "disable_client_user_confirmation_message": "Are you sure you want to disable client user with ID: {{id}}",
    "disable_client_user_success": "You successfully disabled the client user",
    "generate_report": "Generate report",
    "download": "Download",
    "profit": "Profit",
    "income": "Income",
    "profit_per_month": "Profit per month",
    "all_time": "All time",
    "expenses_per_category": "Expenses by category",
    "all_cities": "All cities",
    "related_vouchers_message": "We found additional vouchers linked to this code. Choose the ones you’d like to validate:",
    "validate": "Validate",
    "location": "Location",
    "options": "Options",
    "from": "from",
    "left": "{{count}} left",
    "upload_codes": "Upload codes",
    "update_category": "Update category",
    "choose_option": "Choose option",
    "obtain_voucher": "Get voucher",
    "already_obtained_voucher": "You already have an active voucher.",
    "obtain_voucher_notice": "*By obtaining this voucher, you agree to the <0>Terms & Conditions</0>. The obtained voucher for this wish can be redeemed until: {{expiry}}.",
    "obtain_free_voucher_confirmation": "Are you sure you want to obtain this voucher for “{{wish_name}}”?",
    "free_voucher_note": "You can have only one active voucher for this wish at a time.",
    "prize_stay_tuned": "Stay tuned for the prize",
    "success_obtain_free_voucher": "You successfully obtained the voucher for this wish.",
    "prize_draw": "Prize draw",
}

export type EnglishTranslationsType = typeof enLocale

export default enLocale
